import axios from "axios";
const key = "3PNMU6D0P7CK";
const api = axios.create({
  baseURL: "https://api.timezonedb.com/v2.1",
});

export const getTimeZoneOffset = (lat, lng, time) => {
  console.log("timestamp:", time);
  return api
    .get(
      `/get-time-zone?format=json&by=position&key=${key}&lat=${lat}&lng=${lng}&time=${time}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((r) => {
      return r.data;
    })
    .catch((error) => {
      let message = "";
      if (error.response) {
        message = `${error.response.status} ${
          error.response.statusText
        }\n${JSON.stringify(error.response.data)}`;
        // Request made and server responded
        console.log(error.response);
      } else if (error.request) {
        message = "no response";
        console.log(error.request);
      } else {
        message = error.message;
        console.log("Error", error.message);
      }
      throw new Error(message);
    });
};

const apis = {
  getTimeZoneOffset,
};

export default apis;
